import { type Chain } from 'viem/chains';

// eslint-disable-next-line deprecate/import
import { wagmiConfig } from '@shared/common/providers/LegacyWeb3Provider/wagmi';
import { DEFAULT_TARGET_CHAIN } from '@shared/constants/wallets';

export const getChainById = (chainId?: number): Chain => {
  const foundChain = wagmiConfig.chains.find((chain) => chain.id === chainId);
  return foundChain || DEFAULT_TARGET_CHAIN;
};
